import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminPost, valiadteEmail, valiadteNumber } from "../../redux/Authentication/AuthSlice";
import { createEmployee } from "../../redux/Employee/employeeSlice";
import { FileUploader } from "react-drag-drop-files";
import { CaseActions, UploadChasisImage, UploadFrontImage, UploadOpenBonnet, UploadRearUnderPart, UploadRight45Image, createCase, selfieWithVehicle, selfieWithVehicleUpload, sendVehicleNumber, uploadAnyDamage, uploadExtraImage, uploadExtraImage1, uploadExtraImage2, uploadExtraImage3, uploadFrontUnderCar, uploadGlassInsideImage, uploadGlassOutside, uploadLeft45, uploadLeftImage, uploadOdometerImage, uploadOpenDickey, uploadRcBackImage, uploadRcFront, uploadRearImage, uploadRightImage, uploadRpmImage, uploadSignature, uploadTyreImage, uploadformatImage } from "../../redux/Cases/CaseSlice";
import { useNavigate, useParams } from "react-router-dom";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import FourWheelerEditReport4 from "../Reports/FourWheelerEditReport4";

const AddFarmEquipmentCase = () => {
    const dispatch = useDispatch();
    const params = useParams()
    const navigate=useNavigate()
    const { selfieWithVehicleImage, isSelfieWithAgentLoading, chasisImage, isChasisImageLoading,
        IsformatImageLoading,
        formatImage,
        isOpenBonnetLoading,
        openBonnet,
        isRight45ImageLoading,
        right45image,
        frontimage,
        isFrontImageLoading,
        frontUnderCarImage,
        isFrontUnderCarImageLoading,
        isLeft45Loading,
        left45image,
        isLeftImageLoading,
        leftImage,
        rearImage,
        isRearImageLoading,
        rearUnderPartImage,
        isRearUnderPartLoading,
        openDickeyImage,
        isOpenDickeyImageLoading,
        rightImage,
        isRightImageLoading,
        tyreImage,
        isTyreImageLoading,
        glassOutsideImage,
        isGlassOutsideImageLoading,
        glassInsideImage,
        isGlassInsideImageLoading,
        odometerImage,
        isOdometerImageLoading,
        rpmImage,
        isRpmImageLoading,
        anyDamage,
        isAnyDamageLoading,
        extraImage,
        isExtraImageLoading,
        extraImage1,
        isExtraImage1Loading,
        extraImage2,
        isExtraImage2Loading,
        extraImage3,
        isExtraImage3Loading,
        signatureImage,
        isSignatureImageLoading,
        rcFrontImage,
        isRcFrontImageLoading,
        rcBackImage,
        isRcBackImageLoading
    } = useSelector((store) => store.cases)
    const [assetType, setAssetType] = useState("");
    const [assetTypeError, setAssetTypeError] = useState("");
    const [caseType, setCaseType] = useState("");
    const [caseTypeError, setCaseTypeError] = useState("");
    const [valuationPurpose, setValuationPurpose] = useState('Assesment of fair market value');
    const [valuationPurposeError, setValuationPurposeError] = useState('');
    const [requesterName, setRequesterName] = useState("");
    const [requesterNameError, setRequesterNameError] = useState("");
    const [requesterBranch, setRequesterBranch] = useState("");
    const [requesterBranchError, setRequesterBranchError] = useState("");
    const [requesterPhone, setRequesterPhone] = useState("");
    const [requesterPhoneError, setRequesterPhoneError] = useState("");
    const [email, setEmail] = useState("");
    const [Cnfemail, setCnfEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [mobile, setMobile] = useState("");
    const [mobileCnf, setMobileCnf] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [address, setAddress] = useState("")
    const [addressError, setAddressError] = useState("")
    const [state, setState] = useState("")
    const [stateError, setStateError] = useState("")
    const [cityList, setCityList] = useState([]);
    const [city, setCity] = useState("")
    const [cityError, setCityError] = useState("")
    const [productType, setProductType] = useState("")
    const [productTypeError, setProductTypeError] = useState("")
    const [productBrand, setProductBrand] = useState("")
    const [productBrandError, setProductBrandError] = useState("")
    const [vehicleLocation, setVehicleLocation] = useState('')
    const [vehicleLocationError, setVehicleLocationError] = useState('')
    const [model, setModel] = useState("")
    const [ModelError, setModelError] = useState("")
    const [variant, setVariant] = useState("")
    const [variantError, setVariantError] = useState("")
    const [loanNo, setLoanNo] = useState("")
    const [loanNoError, setLoanNoError] = useState("")
    const [docVerified, setDocVerified] = useState('');
    const [regdOwner, setRegdOwner] = useState("")
    const [regdOwnerError, setRegdOwnerError] = useState("")
    const [regdDate, setRegdDate] = useState("")
    const [regdDateError, setRegdDateError] = useState("")
    const [mfgDate, setMfgdate] = useState('');
    const [numberPlateType, setNumberPlateType] = useState('');
    const [regdNo, setRegdNo] = useState("")
    const [regdNoError, setRegdNoError] = useState("")
    const [vehicleData, setVehicleData] = useState({});
    const [dataFetched, setDataFetched] = useState(false)
    const [engNo, setEngNo] = useState("")
    const [engNoError, setEngNoError] = useState("")
    const [chasisNo, setChasisNo] = useState("")
    const [chasisNoError, setChasisNoError] = useState("")
    const [bodyType, setBodyType] = useState("")
    const [bodyTypeError, setBodyTypeError] = useState("")
    const [meterReading, setMeterReading] = useState('');
    const [fueltype, setFueltype] = useState("")
    const [fueltypeError, setFueltypeError] = useState("")
    const [vehicleColor, setVehicleColor] = useState("")
    const [vehicleColorError, setVehicleColorError] = useState("")
    const [ownerSerialNo, setOwnerSerialNo] = useState("")
    const [ownerSerialNoError, setOwnerSerialNoError] = useState("")
    const [hypothecationBank, setHypothecationBank] = useState("")
    const [hypothecationBankError, setHypothecationBankError] = useState("")
    const [insuranceCompany, setInsuranceCompany] = useState('');
    const [insuranceStatus, setInsuranceStatus] = useState('');
    const [cubicCapacity, setCubicCapacity] = useState("")
    const [cubicCapacityError, setCubicCapacityError] = useState("")
    const [seatingCapacity, setSeatingCapacity] = useState("")
    const [eatingCapacityError, setSeatingCapacityError] = useState("")
    const [vehicleWeight, setVehicleWeight] = useState("")
    const [vehicleWeightError, setVehicleWeightError] = useState("")

    const [selectedVideo, setSelectedVideo] = useState(null);
    const [showLoader, setShowLoader] = useState(false)
    const [videoRecord, setVideoRecord] = useState('')

    const [role, setRole] = useState("")
    const fileTypes = ["JPG", "PNG", "GIF"];

    const [tractorApplication, setTractorApplication] = useState("");
    const [powerHp, setPowerHp] = useState("");
    const [unladenWeight, setUnladenWeight] = useState("");
    const [fitnessExpiryDate, setFitnessExpiryDate] = useState("");
    const [fitnessExpiryDateError, setFitnessExpiryDateError] = useState("");
    const [roadtaxValidityDate, setRoadtaxValidityDate] = useState("");
    const [roadtaxValidityDateError, setRoadtaxValidityDateError] = useState("");
    const [engineStatus, setEngineStatus] = useState("");
    const [engineStatusError, setEngineStatusError] = useState("");
    const [engineCondition, setEngineCondition] = useState("");
    const [engineConditionError, setEngineConditionError] = useState("");
    const [transmission, setTransmission] = useState("");
    const [transmissionError, setTransmissionError] = useState("");
    const [transmissionCondition, setTransmissionCondition] = useState("");
    const [transmissionConditionError, setTransmissionConditionError] =
        useState("");
    const [steering, setSteering] = useState("");
    const [steeringError, setSteeringError] = useState("");
    const [brakes, setBrakes] = useState("");
    const [brakesError, setBrakesError] = useState("");
    const [seatCondition, setSeatCondition] = useState("");
    const [seatConditionError, setSeatConditionError] = useState("");
    const [bodyCondition, setBodyCondition] = useState("");
    const [bodyConditionError, setBodyConditionError] = useState("");
    const [wheelsType, setWheelType] = useState("");
    const [wheelsTypeError, setWheelTypeError] = useState("");
    const [undercarriageCondition, setUndercarriageCondition] = useState("");
    const [undercarriageConditionError, setUndercarriageConditionError] =
        useState("");
    const [paintCondition, setPaintCondition] = useState("");
    const [paintConditionError, setPaintConditionError] = useState("");
    const [lhFront, setLhFront] = useState("");
    const [lhFrontError, setLhFrontError] = useState("");
    const [rhFront, setRhFront] = useState("");
    const [rhFrontError, setRhFrontError] = useState("");
    const [lhRear, setLhRear] = useState("");
    const [lhRearError, setLhRearError] = useState("");
    const [rhRear, setRhRear] = useState("");
    const [rhRearError, setRhRearError] = useState("");
    const [spare, setSpare] = useState("");
    const [spareError, setSpareError] = useState("");
    const [totalTyres, setTotalTyres] = useState("");
    const [totalTyresSpareError, setTotalTyresSpareError] = useState("");
    const [availableTyre, setAvailableTyre] = useState("");
    const [availableTyreError, setAvailableTyreError] = useState("");
    const [missingTyre, setMissingTyre] = useState("");
    const [missingTyreError, setMissingTyreError] = useState("");
    const [spareTyre, setSpareTyre] = useState("");
    const [spareTyreError, setSpareTyreError] = useState("");
    const [battery, setBattery] = useState("");
    const [batteryError, setBatteryError] = useState("");
    const [batteryNumber, setBatteryNumber] = useState("");
    const [batteryNumberError, setBatteryNumberError] = useState("");
    const [starterMotor, setStarterMotor] = useState("");
    const [starterMotorError, setStarterMotorError] = useState("");
    const [instrumentPanel, setInstrumentPanel] = useState("");
    const [instrumentPanelError, setInstrumentPanelError] = useState("");
    const [headLamp, setHeadLamp] = useState("");
    const [headLampError, setHeadLampError] = useState("");
    const [tailLamp, setTailLamp] = useState("");
    const [tailLampError, setTailLampError] = useState("");
    const [workLampsNumbers, setWorkLampsNumbers] = useState("");
    const [workLampsNumbersError, setWorkLampsNumbersError] = useState("");
    const [workLampsCondition, setWorkLampsCondition] = useState("");
    const [workLampsConditionError, setWorkLampsConditionError] = useState("");
    const [electricalsCondition, setElectricalsCondition] = useState("");
    const [electricalsConditionError, setElectricalsConditionError] =
        useState("");
    const [odometerType, setOdometerType] = useState("");
    const [odometerTypeError, setOdometerTypeError] = useState("");
    const [anyAttachmentImplement, setAnyAttachmentImplement] = useState("");
    const [anyAttachmentImplementError, setAnyAttachmentImplementError] =
        useState("");
    const [nameOfAttachmentImplement, setNameOfAttachmentImplement] =
        useState("");
    const [nameOfAttachmentImplementError, setNameOfAttachmentImplementError] =
        useState("");
    const [others, setOthers] = useState("");
    const [othersError, setOthersError] = useState("");
    const [airCompressor, setAirCompressor] = useState("");
    const [airCompressorError, setAirCompressorError] = useState("");
    const [toolKit, setToolKit] = useState("");
    const [toolKitError, setToolKitError] = useState("");
    const [lift, setLift] = useState("");
    const [liftError, setLiftError] = useState("");
    const [tipper, setTipperStatus] = useState("");
    const [tipperError, setTipperStatusError] = useState("");
    const [hitch, setHitch] = useState("");
    const [hitchError, setHitchError] = useState("");
    const [powerSteering, setPowerSteering] = useState("");
    const [powerSteeringError, setPowerSteeringError] = useState("");
    const [whetherAccidental, setWhetherAccidental] = useState("");
    const [whetherAccidentalError, setWhetherAccidentalError] = useState("");
    const [levelOfMaintenance, setLevelOfMaintenance] = useState("");
    const [levelOfMaintenanceError, setLevelOfMaintenanceError] = useState("");
    const [otherRepairsIfAny, setOtherRepairsIfAny] = useState("");
    const [otherRepairsIfAnyError, setOtherRepairsIfAnyError] = useState("");

    const [yourRemark, setYourRemark] = useState("");
    const [exShowRoomPrice, setExShowRoomPrice] = useState("");
    const [exShowRoomPriceError, setExShowRoomPriceError] = useState("");
    const [estimatedPrice, setEstimatedPrice] = useState("");
    const [estimatedPriceError, setEstimatedPriceError] = useState("");

    const selectCaseType = [
        {
            id: 1,
            name: "Revaluation",
        },
        {
            id: 2,
            name: "Repossession",
        },
        {
            id: 3,
            name: "Retail",
        },
        {
            id: 4,
            name: "Insurance Idv",
        },
        {
            id: 5,
            name: "Repurchase",
        },
    ];

    const selectRemarkType = [
        {
          id: 1,
          name: "Poor",
        },
        {
          id: 2,
          name: "Average",
        },
        {
          id: 3,
          name: "Satisfactory",
        },
        {
          id: 4,
          name: "Good",
        },
        {
          id: 5,
          name: "Excellent",
        },
      ];

    const selectRemarkChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setYourRemark(text);
    };
    const selectCaseChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCaseType(text);
    };
    const selectAssetType = [
        {
            id: 1,
            name: "Two Wheeler",
        },
        {
            id: 2,
            name: "Four Wheeler",
        },
        {
            id: 3,
            name: "Commercial",
        },
        {
            id: 4,
            name: "Construction Equipment",
        },
        {
            id: 5,
            name: "Three Wheeler",
        },
        {
            id: 6,
            name: "Farm Equipment",
        },
    ];
    const selectAssetChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAssetType(text);
    };

    const handleRequesterPhn = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setRequesterPhone(value)
    }

    const stateList = [
        { id: 1, name: "Andhra Pradesh" },
        { id: 2, name: "Arunachal Pradesh" },
        { id: 3, name: "Assam" },
        { id: 4, name: "Bihar" },
        { id: 5, name: "Chhattisgarh" },
        { id: 6, name: "Goa" },
        { id: 7, name: "Gujarat" },
        { id: 8, name: "Haryana" },
        { id: 9, name: "Himachal Pradesh" },
        { id: 10, name: "Jharkhand" },
        { id: 11, name: "Karnataka" },
        { id: 12, name: "Kerala" },
        { id: 13, name: "Madhya Pradesh" },
        { id: 14, name: "Maharashtra" },
        { id: 15, name: "Manipur" },
        { id: 16, name: "Meghalaya" },
        { id: 17, name: "Mizoram" },
        { id: 18, name: "Nagaland" },
        { id: 19, name: "Odisha" },
        { id: 20, name: "Punjab" },
        { id: 21, name: "Rajasthan" },
        { id: 22, name: "Sikkim" },
        { id: 23, name: "Tamil Nadu" },
        { id: 24, name: "Telangana" },
        { id: 25, name: "Tripura" },
        { id: 26, name: "Uttar Pradesh" },
        { id: 27, name: "Uttarakhand" },
        { id: 28, name: "West Bengal" },
        { id: 29, name: "Andaman and Nicobar Islands" },
        { id: 30, name: "Chandigarh" },
        { id: 31, name: "Dadra and Nagar Haveli and Daman and Diu" },
        { id: 32, name: "Delhi" },
        { id: 33, name: "Ladakh" },
        { id: 34, name: "Lakshadweep" },
        { id: 35, name: "Puducherry" }
    ];
    const selectStateChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setState(text);
    };
    useEffect(() => {
        if (state) {
            const formData = {
                country: 'India',
                state: state.toLocaleUpperCase(),
            };
            const getCity = async () => {
                try {
                    const config = {
                        headers: { 'Content-Type': 'application/json' },
                    };
                    const url = 'https://countriesnow.space/api/v0.1/countries/state/cities';
                    const resp = await axios.post(url, formData, config);
                    if (!resp.data.error) {
                        const citiesData = resp.data.data.map((city, index) => ({
                            id: index + 1,
                            name: city.toLowerCase().replace(/\s/g, '_'),
                        }));
                        setCityList(citiesData);
                    } else {
                        console.error("Error in response:", resp.data.error); // Log the error for debugging
                    }
                } catch (error) {
                    console.error("Error:", error); // Log any other errors for debugging
                }
            };

            getCity();
        }
    }, [state]);

    const selectCityChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCity(text);
    };

    const handleRegdNo = async (e) => {
        const inputValue = e.target.value.toUpperCase();
        setRegdNo(inputValue);
        setDataFetched(false); // Reset data fetched status

        if (inputValue.length === 9 || inputValue.length === 10) {
            try {
                // let newData = await fetchVehicleData(inputValue);
                const formData = {
                    "regdNo": inputValue,
                }
                const vehicle = await dispatch(sendVehicleNumber(formData))
                setVehicleData(vehicle.payload.response.result);
                setDataFetched(true);
            } catch (error) {
                setVehicleData(null); // Reset vehicle data
            }
        } else {
            setVehicleData(null); // Reset vehicle data if input length is invalid
        }
    };

    useEffect(() => {
        // Fetch data again if required properties are null after initial fetch
        if (dataFetched && vehicleData) {
            const {
                rcFinancer,
                vehicleTaxUpto,
                permitValidUpto,
                permitType,
                vehicleSeatCapacity,
                grossVehicleWeight,
                regAuthority
            } = vehicleData;

            if (
                !rcFinancer ||
                !vehicleTaxUpto ||
                !permitValidUpto ||
                !permitType ||
                !vehicleSeatCapacity ||
                !grossVehicleWeight ||
                !regAuthority
            ) {
                // Required properties are still null, fetch again
                handleRegdNo({ target: { value: regdNo } });
            }
        }
    }, [dataFetched, vehicleData, regdNo]);

    const documents = [
        { name: 'Verified', id: 1 },
        { name: 'Not Verified', id: 2 },
    ];
    const selectDocuementVerifiedTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setDocVerified(text);
    };
    const number = [
        { name: 'White', id: 1 },
        { name: 'Yellow', id: 2 },
        { name: 'Blue', id: 3 },
        { name: 'Black', id: 4 },
    ];
    const selectNumberPlateTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setNumberPlateType(text);
    };
    const options = [
        { name: 'Yes', id: 1 },
        { name: 'No', id: 2 },
    ];
    const odometer = [
        { name: 'Mechanical', id: 1 },
    ];
    const application = [
        { name: 'Agriculture', id: 1 },
    ];
    const attachment = [
        { name: 'One Trolly', id: 1 },
        { name: 'Two Trolly', id: 2 },
    ];
    const Features = [
        { name: "2WD", id: 1 },
        { name: "Manual", id: 2 },
        { name: "Normal", id: 3 },
    ];
    const condition = [
        { name: "Poor", id: 1 },
        { name: "Average", id: 2 },
        { name: "Satisfactory", id: 3 },
        { name: "Good", id: 4 },
        { name: "Excellent", id: 5 },
        { name: "NA", id: 6 },
    ];
    const vehcileBodyType = [
        { name: 'PASSENGER', id: 1 },
        { name: 'GOODS', id: 2 },
    ];
    const reqCondition = [
        { name: "Poor", id: 1 },
        { name: "Average", id: 2 },
        { name: "Satisfactory", id: 3 },
        { name: "Good", id: 4 },
        { name: "Excellent", id: 5 }
    ];
    const list = [
        { name: "10", id: 1 },
        { name: "20", id: 2 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
        { name: "60", id: 6 },
        { name: "70", id: 7 },
        { name: "80", id: 8 },
        { name: "90", id: 9 },
        { name: "100", id: 10 },
    ];
    const qualityList = [
        { name: "Original", id: 1 },
        { name: "Replaced", id: 2 },
    ];
    const wheelTypeList = [
        { name: "Alloy", id: 1 },
        { name: "Steel", value: 2 },
        { name: "Rim", value: 3 },
    ];
    const carSteeringTypeList = [
        { name: 'RACK AND PINION STEERING', id: 1 },
        { name: 'POWER STEERING', id: 2 },
        { name: 'RECIRCULATING BALL STEERING', id: 3 },
    ];
    const selectInsuranceStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setInsuranceStatus(text);
    };

    const handleFileChange = (event) => {
        setSelectedVideo(event.target.files[0])
    };

    const handleUpload = async () => {
        setShowLoader(true)
        const apiKey = '918618947122224';
        const cloudName = 'dexterous-technology';
        const uploadPreset = 'yrevfjck';
        if (selectedVideo) {
            const formData = new FormData();
            formData.append('file', selectedVideo);
            formData.append('upload_preset', 'yrevfjck'); // Replace 'your_upload_preset' with your Cloudinary upload preset

            try {
                const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/video/upload`, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    const responseData = await response.json();
                    setVideoRecord(responseData.secure_url)
                    document.getElementById('videouploading').value = '';
                    setShowLoader(false)
                } else {
                    // Handle upload failure
                    console.error('Failed to upload video to Cloudinary:', response.statusText);
                }
            } catch (error) {
                // Handle network or server errors
                console.error('Error uploading video to Cloudinary:', error);
            }
        } else {
            console.log("No video selected.");
        }
    };

    const handleSelfieWithVehicleChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(selfieWithVehicleUpload({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleChasisChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadChasisImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleFormatChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadformatImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleOpenBonnetChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadOpenBonnet({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleright45Change = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadRight45Image({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const frontImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadFrontImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const frontUnderCarImg = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadFrontUnderCar({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetLeft45Image = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadLeft45({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetLeftImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadLeftImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetRearImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRearImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlerearUnderPartImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadRearUnderPart({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlerearOpenDickeyImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadOpenDickey({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const HandlerightImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRightImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetTyreImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadTyreImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleGlassOutsideImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadGlassOutside({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleGlassInsideImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadGlassInsideImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleOdometerImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadOdometerImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleRpmImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRpmImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleAnyDamage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadAnyDamage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage1 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage1({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage2 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage2({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage3 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage3({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleSignature = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadSignature({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleFrontRc = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRcFront({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleBackRc = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRcBackImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const typeList = [
        { id: 1, name: 'Manual' },
        { id: 2, name: 'Auto' },
    ];

    const [btnPress, setbtnPress] = useState(false);

    const selecttractorApplicationChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTractorApplication(text);
      };
      const selectEngineAvailableChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setEngineStatus(text);
      };
      const selectEngineConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setEngineCondition(text);
      };
      const selectTransmissionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTransmission(text);
      };
      const selectTransmissionConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTransmissionCondition(text);
      };
      const selectSteeringChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setSteering(text);
      };
      const selectBrakesChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setBrakes(text);
      };
      const selectSeatConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setSeatCondition(text);
      };
      const selectBodyConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setBodyCondition(text);
      };
      const selectUndercarriageConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setUndercarriageCondition(text);
      };
      const selectPaintConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setPaintCondition(text);
      };
      const selectLhFrontChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setLhFront(text);
      };
      const selectRhFrontChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setRhFront(text);
      };
      const selectLhRearChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setLhRear(text);
      };
      const selectRhRearChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setRhRear(text);
      };
      const selectSpareChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setSpare(text);
      };
      const selectBatteryChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setBattery(text);
      };
      const selectStarterMotorChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setStarterMotor(text);
      };
      const selectInstrumentPanelChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setInstrumentPanel(text);
      };
      const selectHeadLampChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setHeadLamp(text);
      };
      const selectTailLampChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTailLamp(text);
      };
      const selectWorkLampsConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setWorkLampsCondition(text);
      };
      const selectElectricalsConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setElectricalsCondition(text);
      };
      const selectOdometerTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setOdometerType(text);
      };
      const selectAnyAttachmentImplementChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAnyAttachmentImplement(text);
      };
      const selectNameOfAttachmentImplementChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setNameOfAttachmentImplement(text);
      };
      const selectOthersChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setOthers(text);
      };
      const selectAirCompressorChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAirCompressor(text);
      };
      const selectToolKitChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setToolKit(text);
      };
      const selectLiftChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setLift(text);
      };
      const selectTipperStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTipperStatus(text);
      };
      const selectHitchChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setHitch(text);
      };
      const selectPowerSteeringChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setPowerSteering(text);
      };
      const selectWhetherAccidentalChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setWhetherAccidental(text);
      };
      const selectLevelOfMaintenanceChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setLevelOfMaintenance(text);
      };
      const selectOtherRepairsIfAnyChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setOtherRepairsIfAny(text);
      };
    

    useEffect(() => {
        if (btnPress === true) {
            if (name === "") {
                setNameError("please enter title");
            } else {
                setNameError("");
            }
            if (Cnfemail === "") {
                setEmailError("please enter email");
            } else {
                setEmailError("");
            }
            if (mobileCnf.length !== 10) {
                setMobileError("please enter mobile");
            } else {
                setMobileError("");
            }
        }
    }, [btnPress, name, Cnfemail, mobileCnf]);

    const setNumberChange = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setMobileError("");
        setMobile(value);
        if (value.length === 10) {
            // const verifyNumber = await dispatch(valiadteNumber(value));
            // if (verifyNumber.payload.success) {
            //     setMobileError("Number already exist");
            // } else {
            // }
            setMobileError("");
            setMobileCnf(value);
        } else {
            setMobileError("Please Enter Valid Number");
        }
    };

    const emailChange = async (e) => {
        const value = e;
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        setEmail(value);
        setEmailError("");
        if (value.length > 0) {
            if (value.match(mailformat)) {
                // const verifyEmail = await dispatch(valiadteEmail(value));
                // if (verifyEmail.payload.success) {
                //     setEmailError("Number already exist");
                // } else {
                // }
                setEmailError("");
                setCnfEmail(value);
            } else {
                setEmailError("please enter correct Email format");
            }
        } else {
            setEmailError("please enter correct Email format");
        }
    };

    const cancelClick = async (e) => {
        e.preventDefault();
        setEmail("");
        setCnfEmail("");
        setMobile("");
        setMobileCnf("");
        setName("");
    };

    const handlesubmit = async (e) => {
        e.preventDefault();
        if (name === "") {
            setNameError("please enter title");
        } else {
            setNameError("");
        }
        if (Cnfemail === "") {
            setEmailError("please enter email");
        } else {
            setEmailError("");
        }
        if (mobileCnf.length !== 10) {
            setMobileError("please enter mobile");
        } else {
            setMobileError("");
        }
        if (name !== "" && Cnfemail !== "" && mobileCnf !== "") {
            const formData = {
                assetType: assetType,
                caseType: caseType,
                valuationPurpose: valuationPurpose,
                vehicleLocation: vehicleLocation,
                requesterName: requesterName,
                requesterBranch: requesterBranch,
                requesterPhone: requesterPhone,
                name: name,
                mobile: mobileCnf,
                email: Cnfemail,
                address: address,
                state: state,
                city: city,
                regdNo: regdNo,
                productType: productType,
                brand: productBrand,
                model: model,
                variant: variant,
                loanAgreementNo: loanNo,
                documentVerification: docVerified,
                regdOwner: regdOwner,
                regdDate: regdDate,
                numberPlate: numberPlateType,
                engNo: engNo,
                chasisNo: chasisNo,
                bodyType: bodyType,
                manufacturingDate: mfgDate,
                fueltype: fueltype,
                vehicleColor: vehicleColor,
                ownerSerialNo: ownerSerialNo,
                hypothecationBank: hypothecationBank,
                cubicCapacity: cubicCapacity,
                seatingCapacity: seatingCapacity,
                vehicleWeight: vehicleWeight,
                videos:videoRecord,
                images: {
                    selfieWithVehicle: selfieWithVehicleImage,
                    chasisImage: chasisImage,
                    format: formatImage,
                    openBonnet: openBonnet,
                    right45: right45image,
                    frontImage: frontimage,
                    frontUnderCar: frontUnderCarImage,
                    left45: left45image,
                    leftImage: leftImage,
                    rearImage: rearImage,
                    rearUnderPart: rearUnderPartImage,
                    openDickey: openDickeyImage,
                    rightImage: rightImage,
                    tyreImage: tyreImage,
                    glassOutside: glassOutsideImage,
                    glassInside: glassInsideImage,
                    odometerImage: odometerImage,
                    rpmImage: rpmImage,
                    anyDamage: anyDamage,
                    extraImage:extraImage,
                    extraImage1:extraImage1,
                    extraImage2:extraImage2,
                    extraImage3:extraImage3,
                },
                signNdoc: {
                    sign: signatureImage,
                    rcFront: rcFrontImage,
                    rcBack: rcBackImage,
                },
                farmEquipment: {
                    tractorApplication: tractorApplication,
                    powerHp: powerHp,
                    unladenWeight: unladenWeight,
                    fitnessExpiryDate: fitnessExpiryDate,
                    roadtaxValidityDate: roadtaxValidityDate,
                    engineCondition: engineCondition,
                    transmissionType: transmission,
                    transmissionCondition: transmissionCondition,
                    steering: steering,
                    brakes: brakes,
                    seatCondition: seatCondition,
                    bodyCondition: bodyCondition,
                    wheelsType: wheelsType,
                    undercarriageCondition: undercarriageCondition,
                    paintCondition: paintCondition,
                    lhFront: lhFront,
                    rhFront: rhFront,
                    lhRear: lhRear,
                    rhRear: rhRear,
                    spare: spare,
                    totalTyre: totalTyres,
                    availableTyre: availableTyre,
                    missingTyre: missingTyre,
                    spareTyre: spareTyre,
                    battery: battery,
                    batteryNo: batteryNumber,
                    starterMotor: starterMotor,
                    instrumentPanel: instrumentPanel,
                    headLamp: headLamp,
                    tailLamp: tailLamp,
                    workLampNo: workLampsNumbers,
                    workLampCondition: workLampsCondition,
                    electricalCondition: electricalsCondition,
                    odometerType: odometerType,
                    attachment: anyAttachmentImplement,
                    attachmentName: nameOfAttachmentImplement,
                    otherAttachment: others,
                    airCompressor: airCompressor,
                    ToolKit: toolKit,
                    lift: lift,
                    tipper: tipper,
                    hitch: hitch,
                    powerSteering: powerSteering,
                    accidental: whetherAccidental,
                    maintenanceLevel: levelOfMaintenance,
                    otherRepair: otherRepairsIfAny
                  },
                  yourRemark: yourRemark,
                  valuation: estimatedPrice,
                  marketPrice: exShowRoomPrice,
                  status: 4,
                  statusText: "Case Submitted",
            };
            const newcase = await dispatch(createCase(formData))
            if (newcase.payload.success) {
                alert("Case created successfully");
                dispatch(CaseActions.afterPost())
                navigate('/admin/submittedcases')
                setEmail("");
                setCnfEmail("");
                setMobile("");
                setMobileCnf("");
                setName("");
                setRole("")
                setAddress("")
                setState("")
                setCity("")
                setProductType("")
                setProductBrand("")
                setModel("")
                setVariant("")
                setLoanNo("")
                setDocVerified("")
                setRegdOwner("")
                setRegdDate("")
                setMfgdate("")
                setNumberPlateType("")
                setRegdNo("")
                setEngNo("")
                setChasisNo("")
                setBodyType("")
                setFueltype("")
                setVehicleColor("")
                setOwnerSerialNo("")
                setHypothecationBank("")
                setCubicCapacity("")
                setSeatingCapacity("")
                setVehicleWeight("")
                // setAccidental("")
            }
        } else {
            setbtnPress(true);
        }
    };

    return (
        <>
            <div className="min-h-screen flex flex-col lg:ps-64 w-full">
                <div className="p-6 space-y-6">
                    <div className="flex items-center justify-between w-full print:hidden">
                        <h4 className="text-lg font-semibold text-default-900">
                            Add Farm Equipment Case Details
                        </h4>
                    </div>
                    <div className="shadow rounded-lg bg-white dark:bg-default-50 h-fit">
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Add Farm Equipment Case Details
                            </h4>
                        </div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Case Type *
                                    </label>
                                    <select
                                        className={
                                            caseTypeError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="choices-single-default"
                                        placeholder="This is a search placeholder"
                                        value={selectCaseType.id}
                                        name={selectCaseType.name}
                                        onChange={(e) => selectCaseChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Case Type
                                        </option>
                                        {selectCaseType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fAssetType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Asset Type *
                                    </label>
                                    <select
                                        className={
                                            assetTypeError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fAssetType"
                                        placeholder="This is a search placeholder"
                                        value={selectAssetType.id}
                                        name={selectAssetType.name}
                                        onChange={(e) => selectAssetChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Asset Type
                                        </option>
                                        {selectAssetType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fValuationPurpose"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Purpose Of Valuation *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            valuationPurposeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fValuationPurpose"
                                        placeholder="Enter Valuation Purpose"
                                        value={valuationPurpose}
                                        onChange={(e) => setValuationPurpose(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Valuation Requested By *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterNameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Name"
                                        value={requesterName}
                                        onChange={(e) => setRequesterName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Branch Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterBranchError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Branch"
                                        value={requesterBranch}
                                        onChange={(e) => setRequesterBranch(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterPhoneError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Requester Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={requesterPhone}
                                        onChange={(e) => handleRequesterPhn(e)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            nameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Customer Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer  Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            mobileError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Customer Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={mobile}
                                        onChange={(e) => setNumberChange(e)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Email *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            emailError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="rollNo"
                                        placeholder="Enter Customer Email"
                                        value={email}
                                        onChange={(e) => emailChange(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="Address"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Address *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            addressError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="Address"
                                        placeholder="Enter Customer Address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fState"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Select State *
                                    </label>
                                    <select
                                        className={
                                            stateError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fState"
                                        placeholder="This is a search placeholder"
                                        value={stateList.id}
                                        name={stateList.name}
                                        onChange={(e) => selectStateChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose State Type
                                        </option>
                                        {stateList.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fCity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Select City *
                                    </label>
                                    <select
                                        className={
                                            cityError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fCity"
                                        placeholder="This is a search placeholder"
                                        value={cityList.id}
                                        name={cityList.name}
                                        onChange={(e) => selectCityChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose City Type
                                        </option>
                                        {cityList.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        RegdNo *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            regdNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdNo"
                                        placeholder="Enter Regd No"
                                        value={regdNo}
                                        onChange={(e) => setRegdNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehcileLocation"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Location *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleLocationError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="vehcileLocation"
                                        placeholder="Enter Vehcile Location"
                                        value={vehicleLocation}
                                        onChange={(e) => setVehicleLocation(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="productType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle brand *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            productBrandError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="productType"
                                        placeholder="Enter Vehicle Brand"
                                        value={productBrand}
                                        onChange={(e) => setProductBrand(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="model"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle model *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            ModelError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="model"
                                        placeholder="Enter Vehicle Model"
                                        value={model}
                                        onChange={(e) => setModel(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="variant"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle variant *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            variantError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="variant"
                                        placeholder="Enter Vehicle Variant"
                                        value={variant}
                                        onChange={(e) => setVariant(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="loanNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Loan Agreement No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            loanNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="loanNo"
                                        placeholder="Enter Loan Agreement No"
                                        value={loanNo}
                                        onChange={(e) => setLoanNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fDocVerified"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Document Verified *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fDocVerified"
                                        placeholder="This is a search placeholder"
                                        value={documents.id}
                                        name={documents.name}
                                        onChange={(e) =>
                                            selectDocuementVerifiedTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Status
                                        </option>
                                        {documents.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === docVerified}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdOwner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Regd Owner *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            regdOwnerError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdOwner"
                                        placeholder="Enter regd owner"
                                        value={regdOwner}
                                        onChange={(e) => setRegdOwner(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdOwner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Regd Date *
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            regdDateError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdDate"
                                        placeholder="Enter product regd date"
                                        value={regdDate}
                                        onChange={(e) => setRegdDate(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fManufacturingDate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Manufacturing Date <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fManufacturingDate"
                                        placeholder="Enter Manufacturing Date"
                                        value={mfgDate}
                                        onChange={(e) => setMfgdate(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fNumberPlate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Number Plate Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fNumberPlate"
                                        placeholder="This is a search placeholder"
                                        value={number.id}
                                        name={number.name}
                                        onChange={(e) =>
                                            selectNumberPlateTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Number Plate Type
                                        </option>
                                        {number.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === numberPlateType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="engNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            engNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="engNo"
                                        placeholder="Enter vehicle engine no"
                                        value={engNo}
                                        onChange={(e) => setEngNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="chasisNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Chasis No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            chasisNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="chasisNo"
                                        placeholder="Enter chasis no"
                                        value={chasisNo}
                                        onChange={(e) => setChasisNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="bodyType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Body Type *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            bodyTypeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="bodyType"
                                        placeholder="Enter body type"
                                        value={bodyType}
                                        onChange={(e) => setBodyType(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMeterReading"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Meter Reading *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMeterReading"
                                        placeholder="Enter Meter Reading"
                                        value={meterReading}
                                        onChange={(e) => setMeterReading(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fueltype"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fuel Type*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            fueltypeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fueltype"
                                        placeholder="Enter vehicle fuel type"
                                        value={fueltype}
                                        onChange={(e) => setFueltype(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fueltype"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Color *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleColorError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fueltype"
                                        placeholder="Enter vehicle color "
                                        value={vehicleColor}
                                        onChange={(e) => setVehicleColor(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehicleWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Gross Weight Of Vehicle *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="vehicleWeight"
                                        placeholder="Enter vehicle weight"
                                        value={vehicleWeight}
                                        onChange={(e) => setVehicleWeight(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="ownerSerialNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Owner Serial No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            ownerSerialNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="ownerSerialNo"
                                        placeholder="Enter vehicle owner serial no "
                                        value={ownerSerialNo}
                                        onChange={(e) => setOwnerSerialNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="ownerSerialNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Hypothecation Bank Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            hypothecationBankError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="ownerSerialNo"
                                        placeholder="Enter vehicle hypothecation bank name "
                                        value={hypothecationBank}
                                        onChange={(e) => setHypothecationBank(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceCompany"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Company Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fInsuranceCompany"
                                        placeholder="Enter Insurance Company Name"
                                        value={insuranceCompany}
                                        onChange={(e) => setInsuranceCompany(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Expired *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fInsuranceStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) =>
                                            selectInsuranceStatusChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Insurance Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === insuranceStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="cubicCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Cubic  Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            cubicCapacityError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="cubicCapacity"
                                        placeholder="Enter product Cubic Capacity"
                                        value={cubicCapacity}
                                        onChange={(e) => setCubicCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="seatingCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Seating Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            eatingCapacityError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="seatingCapacity"
                                        placeholder="Enter product seating capacity"
                                        value={seatingCapacity}
                                        onChange={(e) => setSeatingCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="col-span-2 space-y-1">
                                    <label
                                        htmlFor="fLoanAgreement"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Video *
                                    </label>
                                    {
                                        showLoader === true ? (<>
                                            <div style={{ height: '250px', width: '50%', backgroundColor: '#000', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Spinner animation="border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </Spinner>
                                            </div>
                                        </>) : (<>
                                            <iframe
                                                title="Video Player"
                                                width="50%" // Set width to 100% to fill the container
                                                height="250px" // Set height to auto to maintain aspect ratio
                                                src={videoRecord}
                                                frameBorder="0"
                                                allowFullScreen
                                            ></iframe>
                                        </>)
                                    }
                                    <input type="file" id='videouploading' onChange={handleFileChange} accept="video/*" />
                                    {
                                        selectedVideo ? (
                                            <div>
                                                <button onClick={handleUpload} style={{ backgroundColor: '#ff6600', color: '#fff', padding: '5px 8px', borderRadius: '4px' }}>Upload Video</button>
                                            </div>) : (
                                            <div>
                                                <button style={{ backgroundColor: '#ff6600', opacity: '.5', color: '#fff', padding: '5px 8px', borderRadius: '4px' }}>Upload Video</button>
                                            </div>)
                                    }


                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehicleWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Selfie With Vehicle *
                                    </label>
                                    <input type="file" onChange={handleSelfieWithVehicleChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isSelfieWithAgentLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={selfieWithVehicleImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="Chasis Image"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Chasis Image *
                                    </label>
                                    <input type="file" onChange={handleChasisChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isChasisImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={chasisImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="formatfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Product Format Image *
                                    </label>
                                    <input type="file" onChange={handleFormatChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {IsformatImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={formatImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="openBonnetfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Bonnet Image *
                                    </label>
                                    <input type="file" onChange={handleOpenBonnetChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOpenBonnetLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={openBonnet} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="openBonnetfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Right 45* Image *
                                    </label>
                                    <input type="file" onChange={handleright45Change}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRight45ImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={right45image} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front Image *
                                    </label>
                                    <input type="file" onChange={frontImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isFrontImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={frontimage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontUnderCar"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front Under Car Image *
                                    </label>
                                    <input type="file" onChange={frontUnderCarImg}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isFrontUnderCarImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={frontUnderCarImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="left45file"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Left 45* Image *
                                    </label>
                                    <input type="file" onChange={handlesetLeft45Image}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isLeft45Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={left45image} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="leftfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Left Image *
                                    </label>
                                    <input type="file" onChange={handlesetLeftImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isLeftImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={leftImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Rear Image *
                                    </label>
                                    <input type="file" onChange={handlesetRearImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRearImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rearImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearunderpartfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Rear Under Part Image *
                                    </label>
                                    <input type="file" onChange={handlerearUnderPartImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRearUnderPartLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rearUnderPartImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearunderpartfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Dickey Image *
                                    </label>
                                    <input type="file" onChange={handlerearOpenDickeyImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOpenDickeyImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={openDickeyImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="handlerightImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Handle Right Image *
                                    </label>
                                    <input type="file" onChange={HandlerightImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRightImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rightImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="tyreImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tyre Image *
                                    </label>
                                    <input type="file" onChange={handlesetTyreImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isTyreImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={tyreImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="glassOutside"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Glass Outside Image*
                                    </label>
                                    <input type="file" onChange={handleGlassOutsideImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isGlassOutsideImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={glassOutsideImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="glassOutside"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Glass Inside Image*
                                    </label>
                                    <input type="file" onChange={handleGlassInsideImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isGlassInsideImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={glassInsideImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="odometer"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Odometer Image*
                                    </label>
                                    <input type="file" onChange={handleOdometerImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOdometerImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={odometerImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rpmFile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        RPM Image*
                                    </label>
                                    <input type="file" onChange={handleRpmImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRpmImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rpmImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Any Damage *
                                    </label>
                                    <input type="file" onChange={handleAnyDamage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isAnyDamageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={anyDamage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Damage *
                                    </label>
                                    <input type="file" onChange={handleExtraImage}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 1 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage1}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage1Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage1} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 2 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage2}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage2Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage2} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 3 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage3}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage3Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage3} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="signature"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Your Signature*
                                    </label>

                                    <input type="file" onChange={handleSignature}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isSignatureImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={signatureImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontRc"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Frontside of your RC*
                                    </label>
                                    <input type="file" onChange={handleFrontRc}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRcFrontImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rcFrontImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="backRc"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Frontside of your RC*
                                    </label>
                                    <input type="file" onChange={handleBackRc}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRcBackImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rcBackImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fTractorApplication"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tractor Application *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fTractorApplication"
                                        placeholder="This is a search placeholder"
                                        value={application.id}
                                        name={application.name}
                                        onChange={(e) => selecttractorApplicationChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tractor Application
                                        </option>
                                        {application.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === tractorApplication}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fPowerHp"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Power Hp *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fPowerHp"
                                        placeholder="Enter Power Hp"
                                        value={powerHp}
                                        onChange={(e) => setPowerHp(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fUnladenWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Unladen Weight *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fUnladenWeight"
                                        placeholder="Enter Unladen Weight"
                                        value={unladenWeight}
                                        onChange={(e) => setUnladenWeight(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fFitnessExpiryDate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fitness Expiry Date *
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fFitnessExpiryDate"
                                        placeholder="Enter Fitness Expiry Date"
                                        value={fitnessExpiryDate}
                                        onChange={(e) => setFitnessExpiryDate(e.target.value)}
                                    />

                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fRoadTaxValidity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Road Tax Validity Date *
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fRoadTaxValidity"
                                        placeholder="Enter Road Tax Validity"
                                        value={roadtaxValidityDate}
                                        onChange={(e) => setRoadtaxValidityDate(e.target.value)}
                                    />

                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fEngineAvailable"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine Available *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fEngineAvailable"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectEngineAvailableChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Engine Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === engineStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="engineCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            engineConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="engineCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectEngineConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Engine Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === engineCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="transmission"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Transmission Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="transmission"
                                        placeholder="This is a search placeholder"
                                        value={Features.id}
                                        name={Features.name}
                                        onChange={(e) => selectTransmissionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Transmission Type
                                        </option>
                                        {Features.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === transmission}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="transmissionCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Transmission Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            transmissionConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="transmissionCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectTransmissionConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Transmission Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === transmissionCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="steering"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Steering *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="steering"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectSteeringChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Steering
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === steering}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="brakes"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Brakes <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            brakesError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="brakes"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectBrakesChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Brakes
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === brakes}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="seatCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Seat Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="seatCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectSeatConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Seat Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === seatCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="bodyCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Body Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            bodyConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="bodyCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectBodyConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Body Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === bodyCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="undercarriageCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Undercarriage Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="undercarriageCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectUndercarriageConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Undercarriage Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === undercarriageCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="paintCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Paint Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="paintCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectPaintConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Paint Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === paintCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lhFront"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Lh Front <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            lhFrontError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="lhFront"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectLhFrontChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Lh Front
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === lhFront}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rhFront"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Rh Front <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            rhFrontError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="rhFront"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectRhFrontChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Rh Front
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === rhFront}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lhRear"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Lh Rear <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            lhRearError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="lhRear"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectLhRearChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Lh Rear
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === lhRear}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rhRear"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Rh Rear <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            rhRearError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="rhRear"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectRhRearChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Rh Rear
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === rhRear}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="spare"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Spare <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            spareError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="spare"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectSpareChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Spare
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === spare}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fTotalTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Total Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fTotalTyre"
                                        placeholder="Enter Total Tyre"
                                        value={totalTyres}
                                        onChange={(e) => setTotalTyres(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="availableTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Available Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="availableTyre"
                                        placeholder="Enter Available Tyre"
                                        value={availableTyre}
                                        onChange={(e) => setAvailableTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="missingTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Missing Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="missingTyre"
                                        placeholder="Enter Available Tyre"
                                        value={missingTyre}
                                        onChange={(e) => setMissingTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="spareTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Spare Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="spareTyre"
                                        placeholder="Enter Available Tyre"
                                        value={spareTyre}
                                        onChange={(e) => setSpareTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="battery"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Battery *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="battery"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectBatteryChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Battery
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === battery}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="batteryNumber"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Battery Number *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="batteryNumber"
                                        placeholder="Enter Battery Number"
                                        value={batteryNumber}
                                        onChange={(e) => setBatteryNumber(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="starterMotor"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Starter Motor *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="starterMotor"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectStarterMotorChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Starter Motor
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === starterMotor}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="instrumentPanel"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Instrument Panel *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="instrumentPanel"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectInstrumentPanelChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Instrument Panel
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === instrumentPanel}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="headLamp"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Head Lamp *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="headLamp"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectHeadLampChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Head Lamp
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === headLamp}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="tailLamp"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tail Lamp *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="tailLamp"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectTailLampChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tail Lamp
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === tailLamp}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="workLampsNumbers"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Work Lamps Numbers *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="workLampsNumbers"
                                        placeholder="Enter Work Lamps Numbers"
                                        value={workLampsNumbers}
                                        onChange={(e) => setWorkLampsNumbers(e.target.value)}
                                    />
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="workLampsCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Work Lamps Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="workLampsCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectWorkLampsConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Work Lamps Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === workLampsCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="electricalsCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Electricals Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            electricalsConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="electricalsCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectElectricalsConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Electricals Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === electricalsCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="odometerType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Odometer Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="odometerType"
                                        placeholder="This is a search placeholder"
                                        value={odometer.id}
                                        name={odometer.name}
                                        onChange={(e) => selectOdometerTypeChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Odometer Type
                                        </option>
                                        {odometer.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === odometerType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyAttachmentImplement"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Any Attachment/Implement *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="anyAttachmentImplement"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectAnyAttachmentImplementChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Any Attachment/Implement
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === anyAttachmentImplement}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="nameOfAttachmentImplement"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Name Of Attachment/Implement *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="nameOfAttachmentImplement"
                                        placeholder="This is a search placeholder"
                                        value={attachment.id}
                                        name={attachment.name}
                                        onChange={(e) => selectNameOfAttachmentImplementChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Name Of Attachment/Implement
                                        </option>
                                        {attachment.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === nameOfAttachmentImplement}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fOthers"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Others *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fOthers"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectOthersChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Others
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === others}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="airCompressor"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Air Compressor *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="airCompressor"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectAirCompressorChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Air Compressor
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === airCompressor}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="toolKit"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tool Kit *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="toolKit"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectToolKitChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tool Kit
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === toolKit}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lift"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Lift *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="lift"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectLiftChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Lift
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === lift}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="tipper"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tipper *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="tipper"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectTipperStatusChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tipper
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === tipper}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="hitch"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Hitch *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="hitch"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectHitchChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Hitch
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === hitch}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="powerSteering"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        PowerSteering *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="powerSteering"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectPowerSteeringChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose PowerSteering
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === powerSteering}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="whetherAccidental"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Whether Accidental *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="whetherAccidental"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectWhetherAccidentalChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Whether Accidental
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === whetherAccidental}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="levelOfMaintenance"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Level Of Maintenance *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="levelOfMaintenance"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectLevelOfMaintenanceChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Level Of Maintenance
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === levelOfMaintenance}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="otherRepairsIfAny"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Other RepairsIfAny *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="otherRepairsIfAny"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectOtherRepairsIfAnyChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Other Repairs Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === otherRepairsIfAny}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Your Remark On Vehicle *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="choices-single-default"
                                        placeholder="This is a search placeholder"
                                        value={selectRemarkType.id}
                                        name={selectRemarkType.name}
                                        onChange={(e) => selectRemarkChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Case Type
                                        </option>
                                        {selectRemarkType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === yourRemark}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fExShowRoomPrice"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Ex-ShowRoom Price *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            exShowRoomPriceError === ""
                                                ? `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50`
                                                : `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class`
                                        }
                                        id="fExShowRoomPrice"
                                        placeholder="Enter Ex-ShowRoom Price"
                                        value={exShowRoomPrice}
                                        onChange={(e) => setExShowRoomPrice(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fEstimatedPrice"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Estimated Price *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            estimatedPriceError === ""
                                                ? `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50`
                                                : `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class`
                                        }
                                        id="fEstimatedPrice"
                                        placeholder="Enter Estimated Price"
                                        value={estimatedPrice}
                                        onChange={(e) => setEstimatedPrice(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 justify-end" style={{ marginBottom: '60px' }}>
                        <button
                            onClick={(e) => cancelClick(e)}
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border border-transparent align-middle duration-500 text-sm text-center text-red-600 hover:border-red-500/20 hover:bg-red-500/20 rounded transition-all"
                            style={{ outline: 'none' }}
                        >
                            <i className="ph-bold ph-x text-lg" /> cancel
                        </button>
                        <button
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                            onClick={(e) => handlesubmit(e)}
                            style={{ background: "#d93c92", outline: 'none', border: 'none' }}
                        >
                            <i className="ph-duotone ph-cloud-arrow-up text-lg" />
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddFarmEquipmentCase;
